module.exports = __webpack_public_path__ + "img/ic3-gs6.b6f6663e.png";